declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

const PIXEL_ID = '1521190015643127'

export function initMetaPixel() {
  if (typeof window === 'undefined' || window.fbq) return

  const f = window as any
  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function trackAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackSingle', PIXEL_ID, 'AddToCart', {
      content_name: 'CPAP Compliance Rescue',
      content_type: 'product',
      content_ids: ['44196935958621'],
      value: 6.36,
      currency: 'USD',
    })
  }
}

export function trackAndRedirect(url: string) {
  trackAddToCart()
  setTimeout(() => {
    window.open(url, '_blank')
  }, 150)
}

export function trackPurchase() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackSingle', PIXEL_ID, 'Purchase', {
      content_name: 'CPAP Compliance Rescue',
      content_type: 'product',
      content_ids: ['44196935958621'],
      value: 6.36,
      currency: 'USD',
    })
  }
}
